import { graphql } from "@opensea/graphql"
import { recentlyCreatedCurrencyFragment } from "../../utils/currency"

export const NewCurrencyChipFragment = graphql(
  `
    fragment NewCurrencyChip on Currency {
      genesisDate
      ...isRecentlyCreated
    }
  `,
  [recentlyCreatedCurrencyFragment],
)
